export const NAVIGATION_BUTTON_POSITION = {
    toTheSides: 'to-the-sides',
    bellow: 'bellow'
};
